export enum CATALOG_PROJECT_SORT_OPTIONS {
  ALPHABETICAL = 'ALPHABETICAL',
  DATE_POSTED = 'DATE_POSTED',
}

export enum CATALOG_ORGANISATIONS_SORT_OPTIONS {
  ORGANISATION_NAME = 'ORGANISATION_NAME',
  DATE_POSTED = 'DATE_POSTED',
}

export enum CATALOG_PORTFOLIOS_SORT_OPTIONS {
  ALPHABETICAL = 'ALPHABETICAL',
  DATE_POSTED = 'DATE_POSTED',
}

export enum CATALOG_FUNDER_SORT_OPTIONS {
  FUNDER_NAME = 'FUNDER_NAME',
  DATE_POSTED = 'DATE_POSTED',
}

export enum CATALOG_COMMUNITIES_SORT_OPTIONS {
  GROUP_NAME = 'GROUP_NAME',
  DATE_POSTED = 'DATE_POSTED',
}

export const ADMIN_ORGANISATION_SORT_OPTIONS = ['ORGANISATION_NAME', 'DATE_POSTED'];

export const ADMIN_PROJECT_SORT_OPTIONS = ['PROJECT_NAME', 'DATE_POSTED'];

export const ADMIN_FUNDERS_SORT_OPTIONS = ['FUNDER_NAME', 'DATE_POSTED'];

export const ADMIN_COP_SORT_OPTIONS = ['COMMUNITY_NAME', 'DATE_POSTED'];
